'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Images = require('helpers/Images');

var _Images2 = _interopRequireDefault(_Images);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BranchShopCard = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(BranchShopCard, _Component);

  function BranchShopCard() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BranchShopCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BranchShopCard.__proto__ || (0, _getPrototypeOf2.default)(BranchShopCard)).call.apply(_ref, [this].concat(args))), _this), _this.onErrorImage = function (event) {
      var styles = require('./BranchShopCard.scss');
      var target = event.target;
      if (!target.classList.contains(styles.disable)) {
        target.classList.add(styles.disable);
      }
      target.onerror = null;
      target.src = '/error-img.svg';
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BranchShopCard, [{
    key: 'render',
    value: function render() {
      var styles = require('./BranchShopCard.scss');
      var _props = this.props,
          thumbnail = _props.thumbnail,
          averagePoint = _props.averagePoint,
          address = _props.address;

      return _react2.default.createElement(
        'article',
        { className: styles.branch },
        _react2.default.createElement(
          'div',
          { className: styles.detailThumbnail },
          _react2.default.createElement('img', { src: thumbnail, alt: '', onError: this.onErrorImage }),
          averagePoint ? _react2.default.createElement(
            'span',
            null,
            averagePoint
          ) : _react2.default.createElement(
            'span',
            { className: styles.disable },
            '--'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.detailInfo },
          _react2.default.createElement('img', { src: _Images2.default.account.address, alt: '\u0110\u1ECBa ch\u1EC9' }),
          _react2.default.createElement(
            'p',
            null,
            address
          )
        )
      );
    }
  }]);
  return BranchShopCard;
}(_react.Component), _class.propTypes = {
  thumbnail: _react.PropTypes.string,
  averagePoint: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  address: _react.PropTypes.string
}, _temp2);
exports.default = BranchShopCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/BranchShopCard.js
// module id = 1587
// module chunks = 0